export default "__VITE_ASSET__BCLi$E0D__"